import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import Slide from "@material-ui/core/Slide";
import Divider from "@material-ui/core/Divider";

import GroupOutlinedIcon from "@material-ui/icons/GroupOutlined";
import AccessTimeOutlinedIcon from "@material-ui/icons/AccessTimeOutlined";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import LaunchOutlinedIcon from "@material-ui/icons/LaunchOutlined";
import Radio from "@material-ui/core/Radio";
import Tooltip from "@material-ui/core/Tooltip";

import ChildCareOutlinedIcon from "@material-ui/icons/ChildCareOutlined";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import FormatListBulletedOutlinedIcon from "@material-ui/icons/FormatListBulletedOutlined";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ConfirmationNumberOutlinedIcon from "@material-ui/icons/ConfirmationNumberOutlined";
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";

import {
	Link,
	List,
	ListItem,
	ListItemText,
	ListItemSecondaryAction,
} from "@material-ui/core";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function ElevationScroll(props) {
	const { children, target, onElevationChange } = props; // `target` is a ref to the scrollable element
	const [elevated, setElevated] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (target.current) {
				const isElevated = target.current.scrollTop > 100;
				setElevated(isElevated);
				onElevationChange(isElevated);
			}
		};

		const scrollableElement = target.current;
		scrollableElement.addEventListener("scroll", handleScroll);

		return () => {
			scrollableElement.removeEventListener("scroll", handleScroll);
		};
	}, [target, onElevationChange]);

	// Define custom elevation styles
	const elevationStyle = elevated
		? {
				boxShadow: "0 2px 4px 0 rgba(13,22,25,.058)",
				backgroundColor: "#FFF",
		  }
		: {
				boxShadow: "none",
		  };

	// Apply custom styles to the children component
	return React.cloneElement(children, {
		style: { ...children.props.style, ...elevationStyle },
	});
}

const MembershipAdd = ({ open, onClose, ...props }) => {
	const classes = useStyles("BookingFunnel");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

	const hasOptions = true;

	const dialogContentRef = React.useRef(null);

	const [isElevated, setIsElevated] = useState(false);

	const handleElevationChange = (elevated) => {
		setIsElevated(elevated);
	};

	const redeemableServices = [
		{
			category: "Guitar",
			serviceName: "Guitar lessons for kids",
			detail: "30 min",
			price: "$49",
		},
		{
			category: "Guitar",
			serviceName: "Guitar lessons for Adults",
			detail: "30+ min",
			price: "$65+",
		},
		{
			category: "Guitar",
			serviceName: "Yoga class",
			detail: "Mon – Fri • 11:00am – 12:00pm CST • Ages 3 – 8 yrs",
			price: "$65+",
		},
		{
			category: "Yoga",
			serviceName: "Toddler yoga class",
			detail: "Mon – Fri • 11:00am – 12:00pm CST • Ages 3 – 8 yrs",
			price: "$25+",
		},
		{
			category: "Yoga",
			serviceName: "Private yoga service",
			detail: "1 hr",
			price: "$350",
		},
	];

	const servicesByCategory = redeemableServices.reduce((acc, service) => {
		if (!acc[service.category]) {
			acc[service.category] = [];
		}
		acc[service.category].push(service);
		return acc;
	}, {});

	const [selectedOption, setSelectedOption] = useState(null);

	const handleRadioChange = (event) => {
		setSelectedOption(event.target.value);
	};

	// Close dialog

	const handleCloseClick = () => {
		onClose();
	};

	// ClassAddDetails

	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const toggleDialog = () => {
		setIsDialogOpen(!isDialogOpen);
	};

	// ClassAddBooking

	const [isBookingDialogOpen, setIsBookingDialogOpen] = useState(false);

	const toggleBookingDialog = () => {
		setIsBookingDialogOpen(!isBookingDialogOpen);
	};

	const itemsToShow = fullScreen ? 2 : 3;

	const itemData = [
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--XXgODZkV--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/5JhoFGHSQ/IMG_2058.jpg",
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--C2KGRIZd--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/b6hxCnRM/6176e93491123974bf53a923_1_pictures.jpg",
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--Y9udUVtL--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/BSYJytWI7_/IMG_2056.jpg",
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--Md7vbIBI--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/b6hxCnRM/6176e93491123974bf53a923_3_pictures.jpg",
		},
	];

	//

	const redeemableServicesRef = React.useRef(null);

	const handleScrollToServices = () => {
		if (redeemableServicesRef.current) {
			redeemableServicesRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<Dialog
			scroll={"paper"}
			fullScreen={fullScreen}
			fullWidth={true}
			//maxWidth={"sm"}
			open={open}
			onClose={onClose}
			TransitionComponent={Transition}
			keepMounted
			classes={{
				paper: classes.dialogPaper,
				container: classes.dialogContainer,
			}}
			BackdropProps={{
				style: {
					backgroundColor: "rgba(182, 192, 205, 0.6)",
				},
			}}
		>
			<ElevationScroll
				target={dialogContentRef}
				onElevationChange={handleElevationChange}
				{...props}
			>
				<DialogTitle
					style={{
						minHeight: 64,
						textAlign: "left",
						display: "flex",
						alignItems: "center",
					}}
					disableTypography
				>
					<Box position={"absolute"} top={8} left={5}>
						<IconButton aria-label="close" onClick={handleCloseClick}>
							<ArrowBackOutlinedIcon />
						</IconButton>
					</Box>
					{isElevated && (
						<Box
							fontSize={20}
							fontWeight={600}
							className={classes.serviceAddTitle}
							ml={8}
							mr={8}
						>
							Unlimited Yoga Pass
						</Box>
					)}
					<Box position={"absolute"} top={8} right={5}>
						<IconButton aria-label="close" onClick={handleCloseClick}>
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
			</ElevationScroll>
			<DialogContent
				dividers={hasOptions}
				style={{ borderTop: "unset", paddingTop: 0 }}
				ref={dialogContentRef}
			>
				<Box mb={8}>
					<ImageList rowHeight={120} gap={8} cols={fullScreen ? 2 : 3}>
						{itemData.slice(0, itemsToShow).map((item) => (
							<ImageListItem
								key={item.img}
								cols={item.cols || 1}
								className={classes.imageList}
								classes={{ item: classes.imageList }}
							>
								<img src={item.img} />
							</ImageListItem>
						))}
					</ImageList>
				</Box>
				<Box
					fontWeight={600}
					fontSize={28}
					pb={4}
					maxWidth={"90%"}
					lineHeight={1.3}
				>
					Unlimited Yoga Pass
				</Box>
				<Box py={4}>
					<Box display={"flex"} flexDirection={"column"} style={{ gap: 8 }}>
						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<FormatListBulletedOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Sessions:</div>{" "}
								Unlimited
								{/* 15 / month */}
								{/* 15 */}
							</div>
						</Box>

						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<AutorenewIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Renews:</div>{" "}
								Monthly
							</div>
						</Box>

						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<EventAvailableIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Valid for:</div>{" "}
								1 year
							</div>
						</Box>

						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<ConfirmationNumberOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Redeem on:</div>{" "}
								<Link color="primary" onClick={handleScrollToServices}>
									2 services
								</Link>
							</div>
						</Box>

						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<MonetizationOnOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Price:</div> $50
								/ month
								{/* $250 one-time payment */}
							</div>
						</Box>
					</Box>

					<Box mt={6} mb={4}>
						✨ monthly membership ✨ unlimited brazilians for only $55/mo - it
						equals out to about 2-5 FREE brazilians a year, depending on how
						often you get waxed. 🎉 + Plus 10% off products and a free birthday
						gift or add on! 🤩 + follow on instagram : @noodwax *expires after
						one year and then you can repurchase. *early cancellation fee of 2mo
						($110)
					</Box>

					<Link color="primary">See memberships Terms & Conditions</Link>

					{/* <div className={classes.showMoreText}>
							All skill-levels welcome. Our classes are developmentally
							appropriate for the ages listed. We advise all children to be the
							minimum age for the class by the season start date to set them up
							for success in our program. We advise all children to be the
							minimum age for the class by the season start date to set them up
							for success in our program. We advise all children to be the
							minimum age for the class by the season start date to set them up
							for success in our program.
						</div>
						<Link color="primary" onClick={toggleDialog}>
							Show more
						</Link>
						<ClassAddDetails open={isDialogOpen} onClose={toggleDialog} /> */}

					{hasOptions && (
						<>
							<Box my={8}>
								<Divider light />
							</Box>
							<Box
								display={"flex"}
								justifyContent={"space-between"}
								alignItems={"center"}
								pb={4}
							>
								<div>
									<Box
										fontSize={22}
										fontWeight={600}
										mb={1}
										ref={redeemableServicesRef}
									>
										Redeemable services
									</Box>
									<Box color={"grey.600"} fontSize={15}>
										Redeem on 2 services
									</Box>
								</div>

								{/* <Box fontSize={14} fontWeight={600} color={"#c31c3b"}>
									2 spots left!
								</Box> */}
							</Box>
							<div>
								{Object.entries(servicesByCategory).map(
									([category, services]) => (
										<div key={category}>
											<Box fontSize={19} fontWeight={600} mt={6}>
												{category}
											</Box>
											<List>
												{services.map((service, index) => (
													<ListItem
														key={index}
														classes={{
															root: classes.listItem,
															button: classes.listButton,
															container: classes.listItemContainer,
														}}
														disableGutters
													>
														<ListItemText
															classes={{
																primary: classes.listPrimaryThin,
																secondary: classes.listSecondary,
																multiline: classes.listMultiline,
															}}
															primary={service.serviceName}
															secondary={service.detail}
														/>
														<ListItemSecondaryAction>
															<Box color={"#222 !important"} fontWeight={600}>
																{service.price}
															</Box>
														</ListItemSecondaryAction>
													</ListItem>
												))}
											</List>
										</div>
									)
								)}
							</div>
						</>
					)}
				</Box>
			</DialogContent>
			<DialogActions style={{ padding: 24 }}>
				<Box
					display={"flex"}
					flexDirection={"row"}
					justifyContent={"space-between"}
					width={"100%"}
					m={"0 auto"}
					maxWidth={600}
				>
					{/* <Box flexBasis={"48%"}>
						<Button
							fullWidth
							size={"large"}
							//onClick={declineOnClickHandler}
							variant="outlined"
							disableElevation
						>
							Cancel
						</Button>
					</Box> */}
					{/* <Box flexBasis={"48%"}> */}
					<Button
						fullWidth
						//onClick={toggleBookingDialog}
						size={"large"}
						variant="contained"
						color="primary"
						disableElevation
						//disabled={hasOptions ? !selectedOption : false}
					>
						Add to booking
					</Button>

					{/* </Box> */}
				</Box>
			</DialogActions>
		</Dialog>
	);
};

MembershipAdd.propTypes = {};
export default MembershipAdd;
